module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-angry.7ffc87f7.png";